export default {
  playlists (state) {
      return state.playlists
    },
    selectedPlaylist (state) {
        return state.selectedPlaylist
    },
    getFilterResults (state) {
      return state.filterResults
    },
    getPlaylist: state => (id) => {
      return state.playlists.find(item => item.playlistId == id)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/playlists/getters.js